
























































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Signup extends Vue {
	username = "";
	email = "";
	password1 = "";
	password2 = "";
	agreeterms = null;
	showPassword = false;
	loadingSignup = false;

	clear() {
		this.username = "";
		this.email = "";
		this.password1 = "";
		this.password2 = "";
		this.agreeterms = null;
		this.showPassword = false;
		(this.$refs.singupObserver as Vue & { reset: () => boolean }).reset();
	}

	submit() {
		this.loadingSignup = true;
		(this.$refs.singupObserver as Vue & {
			validate: () => any;
		})
			.validate()
			.then((isValid: boolean) => {
				if (isValid) {
					const info: any = {
						name: this.username,
						email: this.email,
						password: this.password1,
						password2: this.password2
					};

					this.$store
						.dispatch("users/registerUser", info)
						.then(res => {
							this.loadingSignup = false;
							this.$vs.notification({
								icon: "<i class='bx bx-bell' ></i>",
								color: "primary",
								position: "top-right",
								title: "Success",
								text: `Accout created successfully for ${info.name}`
							});
							this.$router.push({ name: "Login" });
						})
						.catch(err => {
							this.$vs.notification({
								icon: "<i class='bx bxs-bug' ></i>",
								color: "danger",
								position: "top-right",
								title: "Signup Error",
								text: `Error: ${
									err.error
										? err.error
										: err.email
										? err.email
										: err.password2
										? err.password2
										: "Some thing went wrong!"
								}`
							});
							setTimeout(() => (this.loadingSignup = false), 1000);
						});
				} else {
					setTimeout(() => (this.loadingSignup = false), 2000);
				}
			})
			.catch((err: any) => {
				this.$vs.notification({
					icon: "<i class='bx bxs-bug' ></i>",
					color: "danger",
					position: "top-right",
					title: "Signup Error",
					text: `Error: ${err}`
				});
				setTimeout(() => (this.loadingSignup = false), 1000);
			});
	}
}
